'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';
import ProfileView from '../views/ProfileView.vue';
import { profileEventRoutes } from '../../event/routes/event-routes';

// Profile child routes
let profileChildRoutes = [
  {
    path: '',
    name: 'profile.detail',
    props: true,
    component: () => import('../views/ProfileDetailView.vue'),
  },
];
profileChildRoutes = profileChildRoutes.concat(
  profileEventRoutes,
);

export const profileRoutes = [
  // {
  //   path: '/profile/:userId',
  //   name: 'profile',
  //   component: () => import('../views/ProfileDetailView.vue'),
  //   children: profileChildRoutes
  // },
  {
    path: '/profile',
    component: EmptyRouterView,
    children: [
      {
        path: ':userId',
        component: ProfileView,
        props: true,
        children: profileChildRoutes
      },
    ]
  }
];
